import { render } from "./CrmListViewCreateDealModalButtonsItems.vue?vue&type=template&id=20a75870"
import script from "./CrmListViewCreateDealModalButtonsItems.vue?vue&type=script&lang=js"
export * from "./CrmListViewCreateDealModalButtonsItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__